import type { PageContext } from "vike/types";
import type { Data } from "./+data";
import { blogPostTitle } from "@/lib/seo";

// Single <title>/og:title owner (vike-react renders both from this).
// Same builder as +Head.tsx's twitter:title, never diverge.
export default function title(pageContext: PageContext): string | null {
  const data = pageContext.data as Data | undefined;
  if (!data?.frontmatter) return null;
  return blogPostTitle(data.frontmatter);
}
